import { Selector } from '@ngxs/store';
import { MbbProduct } from '../models/mbb-product.model';
import { CustomerProductMbbState, CustomerProductsMbbStateModel } from './customer-product-mbb.state';

export class CustomerProductMbbSelectors {
  @Selector([CustomerProductMbbState])
  public static getState(state: CustomerProductsMbbStateModel): CustomerProductsMbbStateModel {
    return state;
  }

  @Selector([CustomerProductMbbState])
  static getNewMbbProducts(state: CustomerProductsMbbStateModel): MbbProduct[] {
    return state.products.filter(p => !p.isExistingSubscription);
  }

  @Selector([CustomerProductMbbState])
  static newAndChangedMbbProducts(state: CustomerProductsMbbStateModel): MbbProduct[] {
    return state.products.filter(x => !x.isExistingSubscription || (x.isExistingSubscription && x.mbbSubscription?.id));
  }

  @Selector([CustomerProductMbbState])
  static getExistingMbbProducts(state: CustomerProductsMbbStateModel): MbbProduct[] {
    return state.products.filter(p => p.isExistingSubscription);
  }

  @Selector([CustomerProductMbbState])
  public static selectedStep(state: CustomerProductsMbbStateModel): number {
    return state.selectedMbbStepIndex;
  }

  @Selector([CustomerProductMbbState])
  public static selectedSubscriptionId(state: CustomerProductsMbbStateModel): string {
    return state.selectedMbbSubscriptionId;
  }

  @Selector([CustomerProductMbbState])
  public static products(state: CustomerProductsMbbStateModel): MbbProduct[] {
    return state.products;
  }

  @Selector([CustomerProductMbbSelectors.products])
  public static mbbProductsWithShipping(mbbProducts: MbbProduct[]): MbbProduct[] {
    return mbbProducts.filter((mbbProduct: MbbProduct) => mbbProduct.orderSim);
  }

  @Selector([CustomerProductMbbState])
  public static isLoadingMbbProducts(state: CustomerProductsMbbStateModel): boolean {
    return state.isLoadingExistingProductDetails;
  }
}
